import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncludeTestAccountLookupComponent } from './include-test-account-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [IncludeTestAccountLookupComponent],
  exports: [IncludeTestAccountLookupComponent]
})
export class IncludeTestAccountLookupModule { }
